import { usePlacesHoveredSearchIdSelector } from '~/store/frontendState/places/places.selectors';
import { PlacesSearchOverlayContainer } from './placesSearchOverlay.container';

export const PlacesSearchHoverOverlayContainer = () => {
  const hoveredSearchId = usePlacesHoveredSearchIdSelector();

  if (!hoveredSearchId) {
    return null;
  }

  return (
    <PlacesSearchOverlayContainer searchId={hoveredSearchId} />
  );
};
